import { render, staticRenderFns } from "./PaytourCarousel.vue?vue&type=template&id=0aec87c9&scoped=true"
import script from "./PaytourCarousel.vue?vue&type=script&lang=js"
export * from "./PaytourCarousel.vue?vue&type=script&lang=js"
import style0 from "./PaytourCarousel.vue?vue&type=style&index=0&id=0aec87c9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aec87c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aec87c9')) {
      api.createRecord('0aec87c9', component.options)
    } else {
      api.reload('0aec87c9', component.options)
    }
    module.hot.accept("./PaytourCarousel.vue?vue&type=template&id=0aec87c9&scoped=true", function () {
      api.rerender('0aec87c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/frente_loja/v2/components/PaytourCarousel.vue"
export default component.exports